import { Component, ViewChild, ElementRef, Input } from '@angular/core';
import * as $ from 'jquery'

@Component({
  selector: 'rmt-virtual-scroll',
  templateUrl: 'rmt-virtual-scroll.html'
})
export class RmtVirtualScrollComponent {
  @Input() refItems;
  @ViewChild('container', { read: ElementRef }) container;
  lastRefItems;

  constructor() {
  }

  ngAfterViewInit() {
    this.lastRefItems = this.refItems;
    this.init();
  }

  ngOnChanges() {
    if (this.lastRefItems !== this.refItems) {
      this.lastRefItems = this.refItems
      window.requestAnimationFrame(() => {
        this.update();
      });
    };
  }

  init() {
    const scrolls = $(this.container.nativeElement).parents('.scroll-content');
    if (!scrolls || scrolls.length === 0)
      return;
      
    const scroll = scrolls.get(0);    
    const scrollfunc = scroll.onscroll;
    scroll.onscroll = (ev) => {
      this.update();
      if (scrollfunc)
        scrollfunc.call(scroll, ev);
    }
  }

  update(resetScrollPosition: boolean = false) {
    const scrolls = $(this.container.nativeElement).parents('.scroll-content');
    if (!scrolls || scrolls.length === 0)
      return;
      
    const scroll = scrolls.get(0);
    if (resetScrollPosition)
      scroll.scrollTop = 0;

    const items = this.container.nativeElement.getElementsByTagName('rmt-virtual-scroll-item');
    if (items) {
      let init = true;
      for (let i=0; i < items.length; i++) {
        const item = items[i];
        if (i > 20)
          init = false;
        RmtVirtualScrollComponent.checkItem(item, scroll, init);
      }
    }
  }

  static checkItem(item, scroll, init: boolean = false) {
    const top = scroll.scrollTop - window.innerHeight;
    const bottom = top + (window.innerHeight * 3);
    const child = item.getElementsByClassName('virtual-item-content');
    if (!child || child.length === 0)
      return;
    if (item.offsetTop >= top && (item.offsetTop + item.offsetHeight) <= bottom) {
      child[0].style.display = 'block';
      item.style.opacity = 1.0;
      if (item.callbackRender)
        item.callbackRender(init);
    }
    else {
      child[0].style.display = 'none';
      item.style.opacity = 0.25;
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/rmt-virtual-scroll/rmt-virtual-scroll.ts